export default () => ({
  menuOpen: false,
  dropdownOpen: false,
  sectionOpen: false,
})
